import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent } from '@angular/common/http';
import { RootService } from './root.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  BaseURI : string ;

  constructor(private http:HttpClient ,private rootService : RootService) {
       this.BaseURI =  this.rootService.GetBaseURL();
   }

   public upload(formData) {

    return this.http.post<any>(this.BaseURI + "/CSP/multi-file-upload", formData, {  
        reportProgress: true,  
        observe: 'events'  
      });  
  }

  // public downloadFile(file: string): Observable<HttpEvent<Blob>> {
  //   return this.http.request(new HttpRequest(
  //     'GET',
  //     `${this.BaseURI + "/CSP/file-download"}?file=${file}`,
  //     null,
  //     {
  //       reportProgress: true,
  //       responseType: 'blob'
  //     }));
  // }
  downloadFile(file: string): Observable<any> {
    let url = this.BaseURI+ `/CSP/file-download?file=${file}`;
    return this.http.get(url, { responseType: "blob" });
}
}
